import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MatMenuModule} from "@angular/material/menu";
import {MatToolbarModule} from "@angular/material/toolbar";
import {LayoutModule} from '@angular/cdk/layout';
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatCardModule} from "@angular/material/card";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {FormsModule} from '@angular/forms';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {NavComponent} from './nav/nav.component';
import {LateralControlComponent,CustomLateralControlDialog} from './lateral-control/lateral-control.component';
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDialogModule} from "@angular/material/dialog";
import {MatInputModule} from "@angular/material/input";
import {CodeEditorModule} from "@ngstack/code-editor";
import { TwoIntersectionsComponent } from './two-intersections/two-intersections.component';
import { HighwayTwoLanesComponent } from './highway-two-lanes/highway-two-lanes.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    LateralControlComponent,
    CustomLateralControlDialog,
    TwoIntersectionsComponent,
    HighwayTwoLanesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatMenuModule,
    MatToolbarModule,
    LayoutModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    BrowserAnimationsModule,
    MatRadioModule,
    MatSelectModule,
    FormsModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatDialogModule,
    MatInputModule,
    CodeEditorModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
